"use client";

import { useCurrentFrame, interpolate, spring, useVideoConfig } from "remotion";

export default function CountdownIntro() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const totalCountdownFrames = fps * 3;
  const secondFrames = fps;

  const currentSecond = Math.max(3 - Math.floor(frame / secondFrames), 0);
  const isCountdownDone = frame >= totalCountdownFrames;

  const frameInSecond = frame % secondFrames;
  const ringProgress = frameInSecond / secondFrames;

  const circumference = 2 * Math.PI * 70;
  const dashOffset = isCountdownDone ? circumference : circumference * ringProgress;

  const numberOpacity = isCountdownDone ? 0 : 1;

  const goScale = spring({
    frame: Math.max(frame - totalCountdownFrames, 0),
    fps,
    config: { damping: 8, stiffness: 100 },
  });

  const goOpacity = interpolate(
    frame,
    [totalCountdownFrames, totalCountdownFrames + 5],
    [0, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div style={{ position: "relative", width: 180, height: 180 }}>
        <svg
          width={180}
          height={180}
          style={{ transform: "rotate(-90deg)" }}
        >
          <circle
            cx={90}
            cy={90}
            r={70}
            fill="none"
            stroke="#1e293b"
            strokeWidth={6}
          />
          {!isCountdownDone && (
            <circle
              cx={90}
              cy={90}
              r={70}
              fill="none"
              stroke="#3b82f6"
              strokeWidth={6}
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
              strokeLinecap="round"
            />
          )}
        </svg>
        {!isCountdownDone && (
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              fontSize: "4rem",
              fontWeight: 700,
              opacity: numberOpacity,
              fontFamily: "Inter, sans-serif",
            }}
          >
            {currentSecond}
          </span>
        )}
        {isCountdownDone && (
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${goScale})`,
              color: "#3b82f6",
              fontSize: "3.5rem",
              fontWeight: 800,
              opacity: goOpacity,
              fontFamily: "Inter, sans-serif",
            }}
          >
            GO!
          </span>
        )}
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
